import { ErrorState, formatNumber, IconTitle, Loading } from '@dec/shared';
import { CurrencyExchange, GeoAlt } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import { usePendingDisbursements } from '../hooks/usePendingDisbursements';

export const PendingDisbursementsCard = () => {
  const { t } = useTranslation();
  const { data: disbursements, isLoading, error, refetch } = usePendingDisbursements();

  return (
    <>
      <IconTitle
        title={t('dashboard.pendingDisbursements')}
        icon={CurrencyExchange}
        subtitle={t('dashboard.jurisdictions')}
      />

      {isLoading && <Loading />}

      {error && <ErrorState onRetry={() => void refetch()} />}

      {!isLoading && !error && (
        <div className="row">
          {disbursements?.length === 0 && (
            <div className="p-3">
              <div className="alert alert-info" role="alert">
                {t('disbursement.noPending')}
              </div>{' '}
            </div>
          )}
          {(disbursements ?? []).map((item) => (
            <div className="col mb-2" key={item.jurisdiction}>
              <div className="card h-100">
                <div className="card-body d-flex align-items-center py-4 px-4">
                  <div className="d-flex align-items-center gap-3 mb-4 w-100">
                    <div className="fs-2 text-primary">
                      <GeoAlt size={45} style={{ color: item.color }} />
                    </div>
                    <div className="w-100">
                      <div className="text-uppercase text-muted fw-semibold small mb-2">
                        {item.jurisdictionName}{' '}
                      </div>

                      <div className="fw-bold text-dark text-end" style={{ fontSize: '2rem' }}>
                        {formatNumber(item.value)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};
